export default __webpack_public_path__ + "static/media/80.fc819bf5.jpg";